<template>
  <view-wrapper
    :show-back-button="true"
    name="QualityAssurance - Upload"
    path="qa/labels"
    back-text="Back to labels list"
    :loading="loading"
    loading-text="Loading QualityAssuranceLabelUpload"
    :hasChangesBeenMade="hasChangesBeenMade"
  >
    <wrapper class="mb-3 p-5" :focus="file !== undefined || !changeFile">
      <div>
        <div class="relative mb-3 py-40 bg-primary-light" v-if="!file">
          <div class="inset-0 absolute p-4 flex flex-col">
            <p class="mt-0" v-if="versionId">Replace the previous file (.nlbl)</p>
            <p class="mt-0" v-if="!versionId">Upload file (.nlbl)</p>
            <Dropzone :multiple="false" @filesAdded="onFilesAdded" accept=".nlbl">
              Add file
            </Dropzone>
            <div class="w-full">
              <grafokett-button class="small float-right mt-4" @click="() => { changeFile = false }">Cancel</grafokett-button>
            </div>
          </div>
        </div>
        <div class="p-4 bg-primary-light rounded" v-else>
          <span>{{file === undefined ? 'File not changed' : file.name}}</span>
          <grafokett-button class="small float-right" @click="() => { changeFile = true; file = undefined; }">Change file</grafokett-button>
        </div>
      </div>

      <grafokett-button class="light w-40 mt-4 flex content-center" @click="uploadFiles" :disabled="!file">
        <i class="p-1 upload-symbol"/>
        <span class="text-white inline-block flex-1 p-1">Upload</span>
      </grafokett-button>

      <modal
        v-if="uploadError"
        :type="'error'"
        :heading="'Something went wrong!'"
        :description="'Could not upload files.'"
        @close="uploadError = !uploadError"
      >
        <template slot="buttons" >
          <div>
            <grafokett-button
              class="big ml-2 bg-primary text-textcolor"
              @click="goBack"
            >Go back to details</grafokett-button
            >
          </div>
        </template>
      </modal>

    </wrapper>
  </view-wrapper>
</template>

<script>
import Dropzone from "components/Dropzone";
import GrafokettButton from "components/forms/Button";
import Modal from "components/Modal"
export default {
  data () {
    return {
      loading: false,
      changeFile: false,
      file: undefined,
      selected: {},
      uploadError: false,
    }
  },
  components: {
    Dropzone,
    GrafokettButton,
    Modal
  },
  computed: {
    labelId() {
      return this.$route.params.labelId;
    },
    versionId() {
      return this.$route.params.versionId;
    }
  },
  methods: {
    async uploadFiles() {
      const target = this.versionId ? 'QUALITY_ASSURANCE/REPLACE_LABEL' : 'QUALITY_ASSURANCE/UPLOAD_LABEL'

      try {
        this.loading = true;
        const formData = new FormData()
        formData.append('labelFile', this.file)
        const data = await this.$store.dispatch('DATA/READ_LABEL_VARIABLES_AND_PROPERTIES', formData)
        const payload = {
          labelId: this.labelId,
          versionId: this.versionId,
          fileName: this.file.name,
          fileContent: data.label
        }
        const response = await this.$store.dispatch(target, payload)
        this.selected = {
          labelId: response.entityId,
          versionId: response.versionId
        }
        
        this.$router.push(`/qa/labels/${this.labelId}/versions/${response.versionId}/preview`)

        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.uploadError = true
        throw error
      }
    },
    onFilesAdded(file) {
      this.file = file
    },
    goToPreview() {
      this.$router.push(`/qa/labels/${this.selected.labelId}/versions/${this.selected.versionId}/preview`)
    },
    hasChangesBeenMade() {
      return this.file !== undefined
    },
    goBack() {
      this.router.push(`/qa/labels/${this.selected.labelId}/details`)
    }
  },
}
</script>

